<div class="burger-menu" (click)="toggleSlide($event)">
  <span class="icon-pancake"></span>
</div>
<div class='bread-crumb-trail'>
  <ol class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumb of breadcrumbs; let $index = index">
      <a (click)="backToReports()" *ngIf="!breadcrumb.reportLink">
        {{ breadcrumb.title | translate }}
      </a>
      <a [routerLink]="[breadcrumb.route]" (click)="handleClick(breadcrumb, $index)" [state]="{autorun: true}" *ngIf="breadcrumb.reportLink">
        {{ breadcrumb.title | translate }} {{breadcrumb.isDetailView ? ':' : ''}} <span *ngIf="breadcrumb.isDetailView">{{'DETAIL_VIEW' | translate}}</span>
      </a>
    </li>
  </ol>
  <div class="dm-menu" *ngIf="!(isIframeMode$ | async)">
    <dm-main-header></dm-main-header>
  </div>
</div>
